import { CheckboxGroup } from 'common/components/cookbook/CheckboxGroup';
import { PopoverContent } from 'common/components/cookbook/PopoverContent';
import { Stack } from 'common/components/cookbook/Stack';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { OverrideStatus } from '../api-types';
import { overrideManagementRouteApi } from '../routeApi';

const overrideStatuses: OverrideStatus[] = ['ENDED', 'IMPACTS_FORECAST', 'UPCOMING'] as const;

export const StatusFilterPopoverContent = () => {
  const format = useFormatMessage();
  const { statuses = [] } = overrideManagementRouteApi.useSearch();

  const navigate = overrideManagementRouteApi.useNavigate();

  return (
    <PopoverContent>
      <Stack gap="regularMedium">
        <CheckboxGroup
          name="statuses"
          value={statuses}
          onChange={(value) => {
            void navigate({
              search: (prev) => ({
                ...prev,
                statuses: value.length > 0 ? value : undefined,
                page: undefined,
              }),
            });
          }}
          options={overrideStatuses.map((option) => ({
            label: format(`forecasting.status:${option}`),
            value: option,
          }))}
        />
      </Stack>
    </PopoverContent>
  );
};
